import { FC } from 'react';
import { Button, Descriptions, DescriptionsProps, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { IStudent } from '../../../../models/pushMessage.model';


interface IProps {
  visible: boolean;
  data: string;
  student?: IStudent;
  setVisible: (visible: boolean) => void;
}

const PreviewModal: FC<IProps> = ({ visible, data, setVisible, student }) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={t('sms.send.9')}
            width={900}
            visible={visible}
            footer={[
                <div className='comm-btn__area justify-content-center'>
                  <Button key="cancel" onClick={() => setVisible(false)} className='btn-basic gray'>
                    {t('common.button.close')}
                  </Button>
                </div>
            ]}
        >
            <p style={{ whiteSpace:'pre-wrap' }}>{data}</p>
        </Modal>
    );
};

export default PreviewModal;
